export const LETTER_REGEX = /^(?=.*?[a-z])/;
export const UPPERCASE_REGEX = /^(?=.*?[A-Z])/;
export const LOWERCASE_REGEX = /^(?=.*?[a-z])/;
//eslint-disable-next-line
export const SPECIAL_REGEX = /^(?=.*[!"#$%&'()*+,\-\.\/:;<=>?@\[\\\]\^_`{|}~])/;

export const PASSWORD_REGEX =
  //eslint-disable-next-line
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,.\/:;<=>?@\[\\\]^_`{|}~-])[a-zA-Z0-9!"#$%&'()*+,.\/:;<=>?@\[\\\]^_`{|}~-]{8,64}$/;

export const NUMBER_REGEX = /[0-9]/;

export const POST_CODE_REGEX = /^[A-Z0-9\s-]+$/i;
